import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api } from "../api/client";

const STATUS_LABELS = { draft: "Borrador", review: "En revisión", approved: "Aprobado", obsolete: "Obsoleto" };

export default function VersionsModal({ open, onClose, docId, versions }) {
  const [viewing, setViewing] = useState(null);

  const openVersion = async (v) => {
    const { data } = await api.get(`/documents/${docId}/versions/${v.version_number}`);
    setViewing(data);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto" data-testid="modal-versions">
        <DialogHeader><DialogTitle>Historial de versiones</DialogTitle></DialogHeader>
        {!viewing && (
          <div className="space-y-2">
            {versions.length === 0 && <div className="text-slate-500">Sin versiones.</div>}
            {versions.map((v) => (
              <div key={v.id} className="border border-slate-200 rounded-md p-3 flex items-center justify-between" data-testid={`version-row-${v.version_number}`}>
                <div>
                  <div className="text-[14px] font-medium text-slate-900">v{v.version_number} · {STATUS_LABELS[v.status_at_version] || v.status_at_version}</div>
                  <div className="text-[12px] text-slate-500 mt-1">{new Date(v.created_at).toLocaleString("es-ES")}</div>
                  {v.change_summary && <div className="text-[12px] text-slate-600 mt-1">{v.change_summary}</div>}
                </div>
                <button onClick={() => openVersion(v)} className="text-primary text-[12px] hover:underline" data-testid={`version-view-${v.version_number}`}>Ver</button>
              </div>
            ))}
          </div>
        )}
        {viewing && (
          <div>
            <button onClick={() => setViewing(null)} className="text-primary text-[12px] hover:underline mb-3">← Volver al listado</button>
            <h3 className="font-semibold text-slate-900">Versión {viewing.version_number}</h3>
            <div className="text-[12px] text-slate-500 mb-3">{new Date(viewing.created_at).toLocaleString("es-ES")}</div>
            <div className="prose prose-sm max-w-none border border-slate-200 rounded-md p-4 bg-slate-50">
              <ReactMarkdown>{viewing.content || "_Sin contenido_"}</ReactMarkdown>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
